var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container"},[_c('button',{staticClass:"cancel",style:(_vm.styleObject),on:{"click":_vm.saveChanges}},[_vm._v(_vm._s(_vm.buttonTextC))])])}
var staticRenderFns = []

export { render, staticRenderFns }